import { createSelector } from 'reselect'
import { isSpoofed } from 'selectors/isSpoofed'
import { isPassportCardStartDateWithinAllowedRange } from 'checkout/Components/CheckoutSteps/Review/PassportCardInsurance/passportCardUtils'
import getInsuranceDatesFromCart from './getInsuranceDatesFromCart'
import { hasPassportCardEligibleItems } from '../view/itemViews/getPassportCardQuoteItems'

const isPassportCardInsuranceSupportedSpoofed = createSelector(
  (state: App.State) => state.geo.currentRegionCode,
  (state: App.State) => isSpoofed(state),
  (state: App.State) => getInsuranceDatesFromCart(state)?.startDate,
  (state: App.State) => hasPassportCardEligibleItems(state),
  (
    regionCode,
    spoofed,
    checkoutStartDate,
    cartHasEligibleItems,
  ): boolean => {
    if (regionCode !== 'AU') return false
    if (!spoofed) return false
    if (!isPassportCardStartDateWithinAllowedRange(checkoutStartDate)) return false
    return cartHasEligibleItems
  },
)

export default isPassportCardInsuranceSupportedSpoofed
